// Returns a profile field (first_name, last_name, position, company) in the selected language,
// falling back to the default (French) column when that language has not been filled yet.
export const getProfileField = (profile, field, lang) => {
  if (!profile) return '';
  return profile.translations?.[lang]?.[field] || profile[field] || '';
};
